import { render, staticRenderFns } from "./FormsList.vue?vue&type=template&id=440ca38e&scoped=true&"
import script from "./FormsList.vue?vue&type=script&lang=js&"
export * from "./FormsList.vue?vue&type=script&lang=js&"
import style0 from "./FormsList.vue?vue&type=style&index=0&id=440ca38e&lang=scss&scoped=true&"
import style1 from "./FormsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440ca38e",
  null
  
)

export default component.exports